import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CircuitService } from '../../providers/circuit.service';
import { Circuit } from '../../models/circuit';
import { Horse_show } from '../../models/horse_show';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';

@Component({
  standalone: false,
  selector: 'app-modal-select-circuit-shows',
  templateUrl: './modal-select-circuit-shows.component.html',
styleUrls:  ['./modal-select-circuit-shows.component.css']
})
export class ModalSelectCircuitShowsComponent extends SmsAbstractAppPage implements OnInit {

  horse_shows_selected$: EventEmitter<Horse_show[]>  = new EventEmitter<Horse_show[]>();

  circuit: Circuit = new Circuit({});

  constructor(public activeModal: NgbActiveModal, private circuitService: CircuitService) {
    super();
  }

  ngOnInit(): void {
  }


  setId(id: string): void {
    this.circuitService.get(id).then(circuit => {
      this.circuit = circuit;
    });
  }

  handleCopyToShows(): void {
    let selected_horse_shows: Horse_show[] = [];

    if(this.circuit.current_horse_show != undefined && this.circuit.current_horse_show.selected){
      selected_horse_shows.push(this.circuit.current_horse_show);
    }

    this.circuit.future_horse_shows.forEach(horse_show => {

      if(horse_show.selected){
        selected_horse_shows.push(horse_show);
      }

    });

    if(selected_horse_shows.length > 0){
      this.horse_shows_selected$.emit(selected_horse_shows);
    } else {
      this.handleError("You have not selected any horse shows");
    }

  }

}
